module.exports = __webpack_public_path__ + "static/media/shelves.67c74068.png";